import { FiltersBar } from "components/ui/FiltersBar";
import { GridContainer } from "components/ui/Grid";
import * as _ from "lodash";
import * as React from "react";
import ReactHighCharts from "react-highcharts";
import { Col, Row } from 'reactstrap';
import { IFilters } from "util/userData";
import { getDashboardMetrics, IPlatformMetric } from "./lib/http";
import Highcharts from "highcharts";
import highchartsMore from "highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

interface ISocialMediaDashboardProps {
  filters: IFilters;
}

interface IDashboardState {
  records: IPlatformMetric[];
  averageRating: number;
  percentageOfResponses: number;
  positivePercentage: string;
  daysToRespond: number;
  percentageOfRatingsOverfour: number;
}

export class SocialMediaDashboardContainer extends React.Component<
  ISocialMediaDashboardProps,
  IDashboardState
> {
  state: IDashboardState = {
    records: [],
    averageRating: 0,
    percentageOfResponses: 0,
    positivePercentage: "0",
    daysToRespond: 0,
    percentageOfRatingsOverfour: 0,
  };

  public componentDidMount() {
    highchartsMore(Highcharts);
    solidGauge(Highcharts);
    this.getDashboardData();
  }

  componentWillReceiveProps(nextProps: ISocialMediaDashboardProps) {
    this.getDashboardData(nextProps);
  }

  public getDashboardData(props = this.props) {
    getDashboardMetrics(props.filters).then((records) => {
      let averageRating = 0;
      let responseCount = 0;
      let totalResponses = 0;
      let positiveCount = 0;
      let totalCoded = 0;
      let daysToRespond = 0;
      let percentageOfRatingsOverfour = 0;
      records.map((record) => {
        averageRating = parseFloat(record.averageRating.rating.toFixed(1));
        responseCount += (record.percentResponded / 100.0) * record.totalResponses;
        totalResponses += record.totalResponses;
        daysToRespond = record.averageDaysToRespond;
        positiveCount += record.positiveNumber;
        totalCoded += record.totalCoded
        percentageOfRatingsOverfour = parseFloat(
          (
            (record.reviewSummary.moreThanThree / record.reviewSummary.total) *
            100.0
          ).toFixed(0)
        );
      });

      const percentageOfResponses = totalResponses > 0 ? (responseCount / totalResponses) * 100.0 : 0
      const positivePercentage = totalCoded > 0 ? ((positiveCount / totalCoded) * 100.0).toFixed(1) : "0"
      this.setState({
        records,
        averageRating,
        percentageOfResponses,
        positivePercentage,
        daysToRespond,
        percentageOfRatingsOverfour,
      });
    });
  }

  public renderAverageRating(record) {
    const roundedRating = Math.round(record.averageRating.rating);
    const oneDecimalPlace = parseFloat(record.averageRating.rating).toFixed(1);
    const rating = record.averageRating.rating;

    const starsHtml = [];
    for (let i = 1; i < 6; i++) {
      if (roundedRating >= i) {
        if (rating > i || rating === roundedRating) {
          starsHtml.push(
            <span style={{ color: "gold", fontSize: "30px" }}>★</span>
          );
        } else {
          starsHtml.push(
            <span className="half">
              <div>★</div>
              <div>★</div>
            </span>
          );
        }
      } else {
        starsHtml.push(
          <span style={{ color: "#212121", fontSize: "30px" }}>★</span>
        );
      }
    }
    return (
      <>
        <section
          className="mb-1"
          style={{
            textAlign: "center",
            fontSize: "2.0rem",
            fontWeight: "bold",
            color: "grey",
          }}
        >
          {oneDecimalPlace} AVG
        </section>
        <section className="mb-1 pr-4" style={{ textAlign: "right" }}>
          {record.averageRating.reviews} Reviews
        </section>
        <section>{starsHtml.map((icon) => icon)}</section>
      </>
    );
  }

  public renderMood(record) {
    const commentMoods = record.commentMoods;
    const data = [];

    commentMoods.map((mood) => {
      data.push({ name: mood.name, y: parseInt(mood.y), color: mood.color });
    });

    const categories = [];
    data.map((mood) => {
      categories.push(mood.name);
    });

    const config = {
      chart: {
        type: "bar",
        height: 200,
        backgroundColor: "rgba(0,0,0,0)",
      },
      title: {
        text: null,
      },
      subtitle: {
        text: null,
      },
      xAxis: {
        categories,
        title: {
          text: null,
        },
        lineWidth: 0,
        minorGridLineWidth: 0,
        lineColor: "transparent",
        minorTickLength: 0,
        tickLength: 0,
        labels: {
          useHTML: true,
          style: {
            fontSize: "1.4rem",
          },
          formatter: (x) => {
            if (x.value === "Negative") {
              return '<i class="far fa-frown" style="color: #ffaa00;"></i>';
            }
            if (x.value === "Positive") {
              return '<i class="far fa-smile" style="color: #0493FC;"></i>';
            }
            if (x.value === "Neutral") {
              return '<i class="far fa-meh" style="color: #e7e7e7;"></i>';
            }
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: null,
          align: "high",
        },
        labels: {
          overflow: "justify",
        },
        visible: false,
        gridLineColor: "transparent",
      },
      tooltip: {
        valueSuffix: "%",
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          dataLabels: {
            enabled: true,
            format: "{y}%",
          },
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Comment Sentiment",
          data,
        },
      ],
    };
    return (
      <>
        <ReactHighCharts config={config}></ReactHighCharts>
      </>
    );
  }

  public renderRatingBreakdown(record) {
    const threeOrLessAsPercent = (
      (record.reviewSummary.threeOrLess / record.reviewSummary.total) *
      100.0
    ).toFixed(0);
    const moreThanThreeAsPercent = (
      (record.reviewSummary.moreThanThree / record.reviewSummary.total) *
      100.0
    ).toFixed(0);
    return (
      <>
        <section>
          <Row style={{ textAlign: "center" }}>
            <Col sm={6} style={{ borderRight: "2px solid #D2DEEE" }}>
              <div>
                <span style={{ fontSize: "0.8rem" }}>
                  <span style={{ color: "gold", fontSize: "30px" }}>★</span>
                  <span style={{ color: "gold", fontSize: "30px" }}>★</span>
                  <span style={{ color: "gold", fontSize: "30px" }}>★</span>
                </span>
              </div>
              <span>and below</span>
              <div className="mt-5" style={{ fontSize: "2.0rem" }}>
                {threeOrLessAsPercent}%
              </div>
              <div className="mt-2" style={{ fontSize: "1.0rem" }}>
                {record.reviewSummary.threeOrLess}/{record.reviewSummary.total}{" "}
                review(s)
              </div>
            </Col>
            <Col sm={6}>
              <div>
                <span style={{ fontSize: "0.8rem" }}>
                  <span style={{ color: "gold", fontSize: "30px" }}>★</span>
                  <span style={{ color: "gold", fontSize: "30px" }}>★</span>
                  <span style={{ color: "gold", fontSize: "30px" }}>★</span>
                  <span style={{ color: "gold", fontSize: "30px" }}>★</span>
                </span>
              </div>
              <span>and above</span>
              <div className="mt-5" style={{ fontSize: "2.0rem" }}>
                {moreThanThreeAsPercent}%
              </div>
              <div className="mt-2" style={{ fontSize: "1.0rem" }}>
                {record.reviewSummary.moreThanThree}/
                {record.reviewSummary.total} review(s)
              </div>
            </Col>
          </Row>
        </section>
      </>
    );
  }

  public renderServiceLabel(record) {
    if (record && record.service && record.service.toLowerCase() === "google") {
      return (
        <>
          Google <br /> My Business
        </>
      );
    }
  }

  public renderDaysToRespond(record) {
    const data = record.averageDaysToRespond;

    const options = {
      chart: {
        type: "solidgauge",
        height: 155,
        marginTop: 0,
        backgroundColor: "transparent",
      },
      title: {
        style: { fontSize: "1.0em", fontWeight: "500" },
        text: data + " avg. days to respond",
        y: 140,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false,
          },
        },
      },
      tooltip: {
        enabled: false,
      },
      pane: {
        center: ["50%", "85%"],
        size: "130%",
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor: "#EEE",
          innerRadius: "60%",
          outerRadius: "100%",
          shape: "arc",
        },
      },
      yAxis: {
        stops: [
          [0.2, "#55BF3B"], // green
          [0.6, "#DDDF0D"], // yellow
          [0.7, "#DF5353"], // red
        ],
        lineWidth: 0,
        minorTickInterval: null,
        tickPixelInterval: 400,
        tickWidth: 0,
        title: {
          y: -70,
        },
        labels: {
          y: 16,
        },
        min: 0,
        max: 10,
      },
      series: [
        {
          name: "Days to Respond",
          data: [data],
        },
      ],
    };

    return (
      <>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          ref="solidGaugeChart"
        />
      </>
    );
  }

  render() {
    return (
      <GridContainer className="blacklight">
        <header>
          <h1 className="mt-4 mb-4">
            <span>Social Media Dashboard&nbsp;</span>
          </h1>
        </header>
        <FiltersBar
          hideCommentTypes
          hideHeirarchy
          hideMetrics
          hideQuestions
          hideSearch
          hideSegments
          hideSurveys
          showSocialMediaSource={true}
          showDatePicker={true}
        ></FiltersBar>
        <div className="containerv2" style={{ backgroundColor: "#fff" }}>
          <Row style={{ borderBottom: "2px solid #eee" }}>
            <Col sm={2}></Col>
            <Col sm={4} className="text-center p-3 bg-light">
              <span className="dashboard-group-header">Ratings</span>
            </Col>
            <Col sm={3} className="text-center p-3">
              <span className="dashboard-group-header">Sentiment Type (% of total statements)</span>
            </Col>
            <Col sm={3} className="text-center p-3 bg-light">
              <span className="dashboard-group-header">Response Times</span>
            </Col>
          </Row>
          <Row style={{ borderBottom: "2px solid #eee" }}>
            <Col sm={2}></Col>
            <Col sm={2} className="text-center p-3 bg-light">
              <section>
                <span className="dashboard-header">
                  {this.state.averageRating}
                </span>{" "}
                <br /> <h6>Average Rating - All Sites</h6>
              </section>
            </Col>
            <Col sm={2} className="text-center p-3 bg-light">
              <section>
                <span className="dashboard-header">
                  {" "}
                  {this.state.percentageOfRatingsOverfour}%
                </span>
                <br />
                <h6>review(s) above four stars</h6>
              </section>
            </Col>
            <Col sm={3} className="text-center p-3">
              {" "}
              <span>
                <span className="dashboard-header">
                  {this.state.positivePercentage}%
                </span>{" "}
                <br /> <h6>left positive comments</h6>
              </span>
            </Col>
            <Col sm={3} className="text-center p-3 bg-light">
              <span>
                <span className="dashboard-header">
                  {this.state.percentageOfResponses}%
                </span>{" "}
                <br /> <h6>of reviews had responses</h6>
              </span>
            </Col>
          </Row>
          {this.state.records.map((record) => {
            return (
              <Row
                key={record.service}
                style={{ borderBottom: "2px solid #eee" }}
              >
                <Col sm={2} className="text-center p-3">
                  <span style={{ fontSize: "2.0rem" }}>{record.service}</span>
                  <br />
                  <img
                    src={record.platformIconUrl}
                    alt={record.service}
                    width="25px"
                  />
                </Col>
                <Col sm={2} className="text-center p-3 bg-light">
                  {this.renderAverageRating(record)}
                </Col>
                <Col sm={2} className="text-center p-3 bg-light">
                  {this.renderRatingBreakdown(record)}
                </Col>
                <Col sm={3} className="text-center p-4">
                  {this.renderMood(record)}
                </Col>
                <Col sm={3} className="text-center p-3 bg-light">
                  {this.renderDaysToRespond(record)}
                </Col>
              </Row>
            );
          })}
        </div>
      </GridContainer>
    );
  }
}
